import React, { Component } from 'react'

export const makeToggleable = ({
  attrName = 'isToggled',
  toggleOnName = 'toggleOn',
  toggleOffName = 'toggleOff',
  toggleName = 'toggle',
  defaultValue = false,
} = {}) => {
  return OriginalComponent => {
    return class Toggleable extends Component {
      state = {
        isToggled: defaultValue,
      }

      toggle = isToggled => this.setState({ isToggled })
      toggleOn = e => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({ isToggled: true })
      }
      toggleOff = e => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({ isToggled: false })
      }

      render() {
        return React.createElement(OriginalComponent, {
          ...this.props,
          [attrName]: this.state.isToggled,
          [toggleName]: this.toggle,
          [toggleOnName]: this.toggleOn,
          [toggleOffName]: this.toggleOff,
        })
      }
    }
  }
}
